import { useQueryWithAccessToken } from '../../data-layer/useReactQueryWithAccessToken';
import endpoints from '../../data-layer/endpoints';

export const useGetLinkPreview = (url: string) => {
  let normalizedUrl = url;

  if (normalizedUrl && !normalizedUrl.startsWith('http')) {
    normalizedUrl = `https://${normalizedUrl}`;
  }

  return useQueryWithAccessToken<LinkPreviewData>([endpoints.GetLinkPreview.endpoint, { url: normalizedUrl }], {
    enabled: !!normalizedUrl,
    staleTime: Infinity,
    select: (data: LinkPreviewData) => ({
      ...data,
      media: data.media.filter((mediaItem) => !mediaItem.src.toLowerCase().endsWith('.svg')),
    }),
    retry: false,
  });
};
